import type { FaqItem } from "@/types/faq";

export function truncateText(text: string, max = 120): string {
  if (text.length <= max) return text;
  return `${text.slice(0, max).trimEnd()}…`;
}

export function filterFaqItems(items: FaqItem[], search: string): FaqItem[] {
  const q = search.trim().toLowerCase();
  if (!q) return items;
  return items.filter(
    (it) =>
      it.questionBs.toLowerCase().includes(q) ||
      it.questionEn.toLowerCase().includes(q) ||
      it.answerBs.toLowerCase().includes(q) ||
      it.answerEn.toLowerCase().includes(q),
  );
}
